/* eslint-disable import/no-anonymous-default-export */
import { parsePhoneNumberFromString } from 'libphonenumber-js';

function getTierMarging(pCost, tier) {
  let margin = 0;
  if (pCost <= tier.tier1_amt) {
    margin = tier.tier1;
  } else if (pCost <= tier.tier2_amt) {
    margin = tier.tier2;
  } else if (pCost > tier.tier2_amt) {
    margin = tier.tier3;
  } else {
    margin = tier.tier1;
  }
  return margin;
}

function getCurrentDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function convertUTCToLocalTime(utcTimeString) {
  let dateString = utcTimeString;

  // Check if the date string includes a time component
  if (utcTimeString.includes(':')) {
    dateString += ' UTC'; // Append "UTC" if the time component is present
  }
  //
  // Create a Date object from the date string
  const date = new Date(dateString);

  // Format the local time from the Date object
  const options = {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false, // use 24-hour format; set to true for 12-hour format
    timeZoneName: 'short', // include time zone name
  };

  // If the date string doesn't include a time, remove the time components from the options
  if (!utcTimeString.includes(':')) {
    delete options.hour;
    delete options.minute;
    delete options.second;
    delete options.timeZoneName;
  }

  // Format the local time
  const localTimeString = new Intl.DateTimeFormat('default', options).format(
    date
  );
  return localTimeString;
}

export const formatPhoneNumber = (phoneNumber, threeLetterCode) => {
  const countryCodes = {
    AF: 'AFG',
    AX: 'ALA',
    AL: 'ALB',
    DZ: 'DZA',
    AS: 'ASM',
    AD: 'AND',
    AO: 'AGO',
    AI: 'AIA',
    AQ: 'ATA',
    AG: 'ATG',
    AR: 'ARG',
    AM: 'ARM',
    AW: 'ABW',
    AU: 'AUS',
    AT: 'AUT',
    AZ: 'AZE',
    BS: 'BHS',
    BH: 'BHR',
    BD: 'BGD',
    BB: 'BRB',
    BY: 'BLR',
    BE: 'BEL',
    BZ: 'BLZ',
    BJ: 'BEN',
    BM: 'BMU',
    BT: 'BTN',
    BO: 'BOL',
    BQ: 'BES',
    BA: 'BIH',
    BW: 'BWA',
    BV: 'BVT',
    BR: 'BRA',
    IO: 'IOT',
    BN: 'BRN',
    BG: 'BGR',
    BF: 'BFA',
    BI: 'BDI',
    CV: 'CPV',
    KH: 'KHM',
    CM: 'CMR',
    CA: 'CAN',
    KY: 'CYM',
    CF: 'CAF',
    TD: 'TCD',
    CL: 'CHL',
    CN: 'CHN',
    CX: 'CXR',
    CC: 'CCK',
    CO: 'COL',
    KM: 'COM',
    CG: 'COG',
    CD: 'COD',
    CK: 'COK',
    CR: 'CRI',
    HR: 'HRV',
    CU: 'CUB',
    CW: 'CUW',
    CY: 'CYP',
    CZ: 'CZE',
    DK: 'DNK',
    DJ: 'DJI',
    DM: 'DMA',
    DO: 'DOM',
    EC: 'ECU',
    EG: 'EGY',
    SV: 'SLV',
    GQ: 'GNQ',
    ER: 'ERI',
    EE: 'EST',
    SZ: 'SWZ',
    ET: 'ETH',
    FK: 'FLK',
    FO: 'FRO',
    FJ: 'FJI',
    FI: 'FIN',
    FR: 'FRA',
    GF: 'GUF',
    PF: 'PYF',
    TF: 'ATF',
    GA: 'GAB',
    GM: 'GMB',
    GE: 'GEO',
    DE: 'DEU',
    GH: 'GHA',
    GI: 'GIB',
    GR: 'GRC',
    GL: 'GRL',
    GD: 'GRD',
    GP: 'GLP',
    GU: 'GUM',
    GT: 'GTM',
    GG: 'GGY',
    GN: 'GIN',
    GW: 'GNB',
    GY: 'GUY',
    HT: 'HTI',
    HM: 'HMD',
    VA: 'VAT',
    HN: 'HND',
    HK: 'HKG',
    HU: 'HUN',
    IS: 'ISL',
    IN: 'IND',
    ID: 'IDN',
    IR: 'IRN',
    IQ: 'IRQ',
    IE: 'IRL',
    IM: 'IMN',
    IL: 'ISR',
    IT: 'ITA',
    JM: 'JAM',
    JP: 'JPN',
    JE: 'JEY',
    JO: 'JOR',
    KZ: 'KAZ',
    KE: 'KEN',
    KI: 'KIR',
    KP: 'PRK',
    KR: 'KOR',
    KW: 'KWT',
    KG: 'KGZ',
    LA: 'LAO',
    LV: 'LVA',
    LB: 'LBN',
    LS: 'LSO',
    LR: 'LBR',
    LY: 'LBY',
    LI: 'LIE',
    LT: 'LTU',
    LU: 'LUX',
    MO: 'MAC',
    MG: 'MDG',
    MW: 'MWI',
    MY: 'MYS',
    MV: 'MDV',
    ML: 'MLI',
    MT: 'MLT',
    MH: 'MHL',
    MQ: 'MTQ',
    MR: 'MRT',
    MU: 'MUS',
    YT: 'MYT',
    MX: 'MEX',
    FM: 'FSM',
    MD: 'MDA',
    MC: 'MCO',
    MN: 'MNG',
    ME: 'MNE',
    MS: 'MSR',
    MA: 'MAR',
    MZ: 'MOZ',
    MM: 'MMR',
    NA: 'NAM',
    NR: 'NRU',
    NP: 'NPL',
    NL: 'NLD',
    NC: 'NCL',
    NZ: 'NZL',
    NI: 'NIC',
    NE: 'NER',
    NG: 'NGA',
    NU: 'NIU',
    NF: 'NFK',
    MK: 'MKD',
    MP: 'MNP',
    NO: 'NOR',
    OM: 'OMN',
    PK: 'PAK',
    PW: 'PLW',
    PS: 'PSE',
    PA: 'PAN',
    PG: 'PNG',
    PY: 'PRY',
    PE: 'PER',
    PH: 'PHL',
    PN: 'PCN',
    PL: 'POL',
    PT: 'PRT',
    PR: 'PRI',
    QA: 'QAT',
    RE: 'REU',
    RO: 'ROU',
    RU: 'RUS',
    RW: 'RWA',
    BL: 'BLM',
    SH: 'SHN',
    KN: 'KNA',
    LC: 'LCA',
    MF: 'MAF',
    PM: 'SPM',
    VC: 'VCT',
    WS: 'WSM',
    SM: 'SMR',
    ST: 'STP',
    SA: 'SAU',
    SN: 'SEN',
    RS: 'SRB',
    SC: 'SYC',
    SL: 'SLE',
    SG: 'SGP',
    SX: 'SXM',
    SK: 'SVK',
    SI: 'SVN',
    SB: 'SLB',
    SO: 'SOM',
    ZA: 'ZAF',
    GS: 'SGS',
    SS: 'SSD',
    ES: 'ESP',
    LK: 'LKA',
    SD: 'SDN',
    SR: 'SUR',
    SJ: 'SJM',
    SE: 'SWE',
    CH: 'CHE',
    SY: 'SYR',
    TW: 'TWN',
    TJ: 'TJK',
    TZ: 'TZA',
    TH: 'THA',
    TL: 'TLS',
    TG: 'TGO',
    TK: 'TKL',
    TO: 'TON',
    TT: 'TTO',
    TN: 'TUN',
    TR: 'TUR',
    TM: 'TKM',
    TC: 'TCA',
    TV: 'TUV',
    UG: 'UGA',
    UA: 'UKR',
    AE: 'ARE',
    GB: 'GBR',
    US: 'USA',
    UM: 'UMI',
    UY: 'URY',
    UZ: 'UZB',
    VU: 'VUT',
    VE: 'VEN',
    VN: 'VNM',
    VG: 'VGB',
    VI: 'VIR',
    WF: 'WLF',
    EH: 'ESH',
    YE: 'YEM',
    ZM: 'ZMB',
    ZW: 'ZWE',
  };
  const twoLetterCountryCode = Object.entries(countryCodes).find(
    ([key, value]) => value === threeLetterCode
  );
  //return entry ? entry[0] : undefined;

  if (!twoLetterCountryCode) {
    return phoneNumber;
  }
  const phoneNumberObj = parsePhoneNumberFromString(
    phoneNumber,
    twoLetterCountryCode[0]
  ); // 'ZW' for Zimbabwe
  if (!phoneNumberObj) {
    return phoneNumber; // return the original phone number if it can't be parsed
  }
  return phoneNumberObj.formatInternational();
};

export default {
  convertUTCToLocalTime,
  formatPhoneNumber,
  getTierMarging,
  getCurrentDate,
};

export const howItWorks = [
  {
    imgUrl: '/images/register.svg',
    category: 'Register',
    description: 'Simply sign up for FREE',
  },
  {
    imgUrl: '/images/healthcareProvider.svg',
    category: 'Select A Healthcare  Provider',
    description: ' Select your preferred provider. ',
  },
  {
    imgUrl: '/images/appoitment.svg',
    category: 'Book an Appointment',
    description: 'Book an Appointment online',
  },
  {
    imgUrl: '/images/pay.svg',
    category: 'pay online',
    description: 'Securely pay online.',
  },
];

export const faqPoints = [
  {
    heading: 'What is Total Urgent Health?',
    description:
      'Total Urgent Health is an online platform designed to connect patients with healthcare providers across Zimbabwe. We facilitate secure online payments, making it easy for patients and their families, including those living abroad, to access and pay for medical services.',
  },
  {
    heading: 'How do I register on Total Urgent Health?',
    description:
      'To register, visit our website at www.totalurgenthealth.com and click on the “Register” button. Follow the prompts to create your account, provide the necessary information, and you’ll be ready to start using our services.',
  },
  {
    heading:
      'What types of healthcare services are available on Total Urgent Health?',
    description:
      'Our platform provides access to a wide range of healthcare services, including but not limited to; general consultations, medical appointments, laboratory tests, and medication delivery. We connect you with general practitioners, specialists, pharmacies, and diagnostic centers.',
  },
  {
    heading: ' How can my family abroad pay for my medical services?',
    description:
      'Family members in the diaspora can securely make payments for your medical services through our online platform. They can use various payment methods to ensure you receive the healthcare you need without financial hurdles.',
  },
  {
    heading:
      ' Is my personal and payment information secure on Total Urgent Health?',
    description:
      'Yes, we prioritize the security and confidentiality of your information. Our platform uses advanced encryption and secure payment gateways to protect your personal and financial data.',
  },
  {
    heading:
      ' Can I book an appointment with a specialist through Total Urgent Health?',
    description:
      'Absolutely! You can search for and book appointments with a wide range of specialists, including cardiologists, dermatologists, pediatricians, and more. Our platform makes it easy to find the right healthcare provider for your needs.',
  },
  {
    heading: 'Can I get my medications delivered to my home?',
    description:
      'Yes, some of our partners offer medication delivery services. Once your prescription is ready, you can choose to have it delivered to your home or pick it up from a nearby pharmacy listed on our platform.',
  },
  {
    heading:
      'What should I do if I need technical support or have questions about the platform?',
    description:
      'If you need assistance, you can contact our customer support team through the “Contact Us” section on our website. We offer support via email, phone, and live chat to help you with any issues or questions.',
  },
  {
    heading: 'Are there any fees for using Total Urgent Health?',
    description: 'Registration on Total Urgent Health is free',
  },
];

export const whyChooseUs = [
  {
    text: 'Secure & Reliable Diaspora Payments',
    imgUrl: '/images/credit-mac.jpg',
  },
  {
    text: '24/7 Support When You Need it',
    imgUrl: '/images/customer-care.png',
  },
  {
    text: 'Access a Wide Network of Healthcare Providers',
    imgUrl: '/images/doctor.png',
  },
  {
    text: 'Schedule Appointments with Your Preferred Provider',
    imgUrl: '/images/man-on-chair.png',
  },
];

export const medicalData = [
  {
    imgUrl: '/images/primarycare.svg',
    category: 'Primary care',
    description: 'Diagnostics and prevention',
  },
  {
    imgUrl: '/images/neurology.svg',
    category: 'neurology',
    description: 'Nervous system disorders',
  },
  {
    imgUrl: '/images/pediatrics.svg',
    category: 'pediatrics',
    description: 'Premium care for children',
  },
  {
    imgUrl: '/images/cardio.svg',
    category: 'cardiology',
    description: 'Treating heart diseases',
  },
];
